import React from 'react';
import Instructor from '../../../assets/Images/Instructor.png';
import HighlightText from './HighlightText';
import CTAButton from './Button';
import { FaArrowRight } from 'react-icons/fa';

const InstructorSection = () => {
    return (
        <div className='mt-20'>
            <div className='flex lg:flex-row flex-col gap-20 items-center'>
                <div className=''>
                    <img
                        src={Instructor}
                        alt='InstructorImage'
                        loading='lazy'
                        className='md:shadow-[-20px_-20px_rgba(255,255,255)] shadow-[-10px_-10px_rgba(255,255,255)] object-cover'
                    />
                </div>
                <div className='lg:w-[50%] w-full flex flex-col '>
                    <h3 className='md:text-4xl text-3xl font-bold mb-10'>
                        Become an <span className=''><HighlightText text={'Instructor'} /></span>
                    </h3>
                    <p
                        className='text-richblack-400 text-lg text-justify'
                    >
                        Instructors from around the world teach millions of students on StudyNexaa. We provide the tools and skills to teach what you love.
                    </p>
                    <div className='mt-12'>
                        <CTAButton linkTo={'/login'} active={true}>
                            <div className='flex items-center justify-center gap-3'>
                                Start Teaching Today
                                <span>
                                    <FaArrowRight />
                                </span>
                            </div>
                        </CTAButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InstructorSection;